import JSBI from 'jsbi'

export const INIT_CODE_HASH = '0xc2e4c237838adf5a2da019f9e4187863789f74e6dede23349b5e8f63a1a42500'

export const MINIMUM_LIQUIDITY = JSBI.BigInt(1000)

// exports for internal consumption
export const ZERO = JSBI.BigInt(0)
export const ONE = JSBI.BigInt(1)
export const FIVE = JSBI.BigInt(5)
export const _997 = JSBI.BigInt(997)
export const _1000 = JSBI.BigInt(1000)
